export default {
  'app.pwa.offline': 'Vous êtes hors ligne maintenant',
  'app.pwa.serviceworker.updated': 'Nouveau contenu disponible',
  'app.pwa.serviceworker.updated.hint':
    'Veuillez appuyer sur le bouton "Actualiser" pour recharger la page actuelle',
  'app.pwa.serviceworker.updated.ok': 'Actualiser',
};
